<template>
  <div id="schedule">
    <v-btn class="action" color="primary" :disabled="loading" @click="save">
      Save
    </v-btn>
    <v-btn class="action" color="grey" dark @click="refresh">Refresh</v-btn>
    <v-btn class="action" color="red darken-2" dark to="/schedule-advanced"
      >Advanced</v-btn
    >
    <v-container v-if="!loading" fluid>
      <v-tabs v-model="tab">
        <v-tab v-for="b of this.bots" :key="b.name"> {{ b.name }}</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item v-for="(bot, i) of this.bots" :key="bot.name" :value="i">
          <bookie-schedule
            v-for="bookie of bot.schedule.AutomatedTimes"
            :key="bookie.Bookie"
            :schedule="bookieSchedule(bot.name, bookie.Bookie)"
            v-on:add-time="() => addTime(bot.name, bookie.Bookie)"
            v-on:remove-time="
              index => removeTime(bot.name, bookie.Bookie, index)
            "
          />
        </v-tab-item>
      </v-tabs-items>
    </v-container>
    <v-container fill-height fluid class="load-parent">
      <v-progress-circular
        v-if="loading"
        indeterminate
        color="primary"
        class="loader"
      ></v-progress-circular>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import BookieSchedule from "../components/bookie_schedule/BookieSchedule.vue";
import { get, saveSchedule } from "../lib/bots";

export default {
  name: "ScheduleBasic",
  components: {
    BookieSchedule
  },
  data() {
    return {
      loading: true,
      tab: null,
      bots: []
    };
  },
  methods: {
    addTime(bot, bookie) {
      const botSchedule = this.bots.find(b => b.name === bot);

      if (botSchedule) {
        const bookieSchedule = botSchedule.schedule.AutomatedTimes.find(
          b => b.Bookie === bookie
        );

        if (bookieSchedule) {
          bookieSchedule.Times.push({
            Start: "00:00",
            End: "00:01"
          });
        }
      }
    },
    removeTime(bot, bookie, index) {
      const botSchedule = this.bots.find(b => b.name === bot);

      if (botSchedule) {
        const bookieSchedule = botSchedule.schedule.AutomatedTimes.find(
          b => b.Bookie === bookie
        );

        if (bookieSchedule) {
          if (bookieSchedule.Times.length > 1) {
            bookieSchedule.Times.splice(index, 1);
          } else {
            Vue.set(bookieSchedule.Times, 0, {
              Start: "00:00",
              End: "00:01"
            });
          }
        }
      }
    },
    bookieSchedule(bot, bookie) {
      const botSchedule = this.bots.find(b => b.name === bot);
      if (!botSchedule) return [];

      const bookieSchedule = botSchedule.schedule.AutomatedTimes.find(
        b => b.Bookie === bookie
      );
      return bookieSchedule || [];
    },
    async save() {
      try {
        this.loading = true;
        const b = this.bots[this.tab];
        await saveSchedule(b.name, b.schedule);
        this.loading = false;
      } catch (err) {
        this.showError(`Unable to save schedule - ${err}`);
      }
    },
    async refresh() {
      try {
        this.loading = true;
        const resp = await get();
        this.bots = resp
          .filter(b => b.active)
          .map(b => {
            const s = {
              DefaultTimes: b.schedule.DefaultTimes,
              AutomatedTimes: b.schedule.AutomatedTimes,
              ManualOverrides: b.schedule.ManualOverrides
            };

            return {
              name: b.sort,
              schedule: s
            };
          });
        this.loading = false;
      } catch (err) {
        this.showError(`Unable to read schedule - ${err}`);
      }
    }
  },
  async mounted() {
    this.refresh();
  }
};
</script>

<style lang="scss">
#schedule {
  .load-parent {
    min-height: 300px;
    width: 100%;

    .loader {
      margin: auto;
    }
  }

  .action {
    margin-right: 4px;
  }
}
</style>
